import { Route } from 'vue-router'

export function beforeEach (to: Route, from: Route, next) {
  next()
}
